import styled, { css } from 'styled-components';
import { keyframeFadeIn } from '../../styles/keyFrames';
import { MAX_WIDTH } from './positionEquations';
import { EXTRA_MARGIN, getHeighForStaticToolTip } from '../../utils/flyoutPositionHelper/flyoutPositionHelper';
export var wrapperAnimation = function wrapperAnimation(props) {
  var animation = props.animation;
  if (animation === 'fadeIn') {
    return css(["", " 0.2s ease-in-out;"], keyframeFadeIn);
  }
  return css(["", " 0.2s ease-in-out;"], keyframeFadeIn);
};
var adjustPadding = function adjustPadding() {
  var side = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  switch (side) {
    case 'bottomLeft':
      return css(["padding-bottom:0;padding-left:0;"]);
    case 'topLeft':
      return css(["padding-bottom:0;padding-left:0;padding-top:0;"]);
    case 'topRight':
      return css(["padding-top:0;padding-right:0;"]);
    case 'bottomRight':
      return css(["padding-bottom:0;padding-right:0;padding-top:0;"]);
    default:
      return css(["padding:", "px;"], EXTRA_MARGIN);
  }
};
var adjustTranslation = function adjustTranslation(_ref) {
  var x = _ref.x,
    y = _ref.y;
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  switch (side) {
    case 'bottom':
    case 'top':
    case 'left':
    case 'right':
      return css(["transform:translateX(", "px) translateY(", "px);"], Math.ceil(x), Math.ceil(y));
    case 'topLeft':
    case 'bottomLeft':
      return css(["transform:translateX(", "px) translateY(", "px);"], Math.ceil(x), Math.ceil(y + EXTRA_MARGIN));
    default:
      return css(["transform:translateX(", "px) translateY(", "px);"], Math.ceil(x + EXTRA_MARGIN / 2), Math.ceil(y + EXTRA_MARGIN));
  }
};
export var FlyoutWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "style__FlyoutWrapper",
  componentId: "sc-1llcjbs-0"
})(["position:fixed;top:0;left:0;width:auto;max-width:", "vw;height:", ";", " animation:", ";", ";z-index:2;", ";"], MAX_WIDTH, function (_ref2) {
  var parent = _ref2.parent,
    isStatic = _ref2.isStatic,
    side = _ref2.side;
  return getHeighForStaticToolTip(parent, isStatic, side);
}, function (_ref3) {
  var isStatic = _ref3.isStatic;
  return isStatic && 'overflow-y: auto;';
}, wrapperAnimation, function (_ref4) {
  var position = _ref4.position,
    calculatedSide = _ref4.calculatedSide;
  return adjustTranslation(position, calculatedSide);
}, function (props) {
  return adjustPadding(props.side);
});
export var ScrollableContent = /*#__PURE__*/styled.div.withConfig({
  displayName: "style__ScrollableContent",
  componentId: "sc-1llcjbs-1"
})(["border:1px solid;border-color:", ";height:100%;max-height:", ";max-width:", ";overflow-x:hidden;overflow-y:auto;width:100%;"], function (_ref5) {
  var border = _ref5.border,
    theme = _ref5.theme;
  return border === 'primary' ? theme.colors.border.primary : theme.colors.border.midGray;
}, function (props) {
  return props.maxHeight ? "".concat(props.maxHeight, "px") : '275px';
}, function (props) {
  return props.maxWidth ? "".concat(props.maxWidth, "px") : '100%';
});
export var Frame = /*#__PURE__*/styled.div.withConfig({
  displayName: "style__Frame",
  componentId: "sc-1llcjbs-2"
})(["box-shadow:0 0.125rem 0.5rem 0 rgba(0,0,0,0.21);padding:", ";background:", ";position:relative;z-index:", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.spacing.sp16;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.background.white;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.stacking.infront;
});